module.exports = __webpack_public_path__ + "media/teams/CPD-teams-d6a38f92.png";